import React from "react";

export default function Header() {
    return (
        <header className="bg-slate-900 text-white sticky top-0 z-50 shadow-md">
            <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center">
                <h1 className="font-bold text-lg text-center">Clayton Car Contracts</h1>
                <nav className="flex gap-4 text-sm text-center">
                    <a href="#/">Home</a>
                    <a href="#/about">About</a>
                    <a href="#/deals">Deals</a>
                    <a href="#/contact">Contact Us</a>
                </nav>
            </div>
        </header>
    );
}
